import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const StyledLink = styled(Link)`
    text-decoration: none;
    margin-right: 20px;
    font-size: 20px;
    padding: 1.2em 0.4em;
    display: block;

    color: ${(props) => (props.mode === 'light' ? '#222' : 'white')};

    &:hover {
        color: ${(props) => (props.mode === 'light' ? props.theme.colors.accentHover : props.theme.colors.teal.tint3)};
    }

    &.nav-link--active {
        color: ${(props) => props.theme.colors.accent};
        box-shadow: inset 0px -4px 0px 0px;
    }
`;

const Navigation = ({ mode = 'light' }) => {
    return (
        <nav className="nav">
            <ul>
                <li>
                    <StyledLink
                        to="/brand"
                        mode={mode}
                        className="nav-link"
                        activeClassName="nav-link--active"
                        partiallyActive={true}
                    >
                        Brand
                    </StyledLink>
                </li>
                <li>
                    <StyledLink
                        to="/writing"
                        mode={mode}
                        className="nav-link"
                        activeClassName="nav-link--active"
                        partiallyActive={true}
                    >
                        Content
                    </StyledLink>
                </li>
                <li>
                    <StyledLink
                        to="/foundations"
                        mode={mode}
                        className="nav-link"
                        activeClassName="nav-link--active"
                        partiallyActive={true}
                    >
                        Foundations
                    </StyledLink>
                </li>
                <li>
                    <StyledLink
                        to="/components"
                        mode={mode}
                        className="nav-link"
                        activeClassName="nav-link--active"
                        partiallyActive={true}
                    >
                        Components
                    </StyledLink>
                </li>
            </ul>
        </nav>
    );
};

Navigation.propTypes = {
    mode: PropTypes.string,
};

Navigation.defaultProps = {};

export default Navigation;
